module.exports = __webpack_public_path__ + "static/media/banner1@2x.71285c00.png";